import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// styles
import './styles/Notfound.css';
import { Grid, Paper } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { AppContext } from '../Context/AppContextProvide';
import { useContext } from 'react';

export default function Notfound() {
  const { isLoggedOut } = useContext(AppContext);
  localStorage.setItem('returnUrl', '');
  const history = useHistory();



  return (
    <div style={{margin: "120px 10px 20px"}}>
      <Paper elevation={15} style={{padding: "10px 10px 20px", maxWidth: "600px", margin: "auto"}}>
        { isLoggedOut ? (
            <Grid container spacing={3} style={{textAlign: "center"}}>
              <Grid item xs={12}>
                <Typography variant="h4">Login</Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  style={{width: "50%"}}
                  size='large'
                  onClick={() => history.push('/signin')}
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2} style={{padding: "20px 10px"}}>
              <Grid item xs={12}>
                <Typography variant="h4" style={{textAlign: "center"}}>Page Not Found</Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  size='large'
                  onClick={() => history.goBack()}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  size='large'
                  style={{color: "#28C4FC", backgroundColor: "#142E3E"}}
                  onClick={() => history.push('/home')}
                >
                  Home
                </Button>
              </Grid>
            </Grid>
          )
        }
      </Paper>
    </div>
  );
};
